export const RECOMMEND_BANNER_REQUEST = 'RECOMMEND_BANNER_REQUEST';
export const RECOMMEND_BANNER_SUCCESS = 'RECOMMEND_BANNER_SUCCESS';
export const RECOMMEND_BANNER_FAILURE = 'RECOMMEND_BANNER_FAILURE';

export const RECOMMEND_WEEK_HOTS_REQUEST = 'RECOMMEND_WEEK_HOTS_REQUEST';
export const RECOMMEND_WEEK_HOTS_SUCCESS = 'RECOMMEND_WEEK_HOTS_SUCCESS';
export const RECOMMEND_WEEK_HOTS_FAILURE = 'RECOMMEND_WEEK_HOTS_FAILURE';

export const RECOMMEND_RECOMMEND_REQUEST = 'RECOMMEND_RECOMMEND_REQUEST';
export const RECOMMEND_RECOMMEND_SUCCESS = 'RECOMMEND_RECOMMEND_SUCCESS';
export const RECOMMEND_RECOMMEND_FAILURE = 'RECOMMEND_RECOMMEND_FAILURE';

export const RECOMMEND_GROUP_REQUEST = 'RECOMMEND_GROUP_REQUEST';
export const RECOMMEND_GROUP_SUCCESS = 'RECOMMEND_GROUP_SUCCESS';
export const RECOMMEND_GROUP_FAILURE = 'RECOMMEND_GROUP_FAILURE';

export const GUESS_LIKES_REQUEST = 'GUESS_LIKES_REQUEST';
export const GUESS_LIKES_SUCCESS = 'GUESS_LIKES_SUCCESS';
export const GUESS_LIKES_FAILURE = 'GUESS_LIKES_FAILURE';

export const GET_SOFTINFOS_REQUEST = 'GET_SOFTINFOS_REQUEST';
export const GET_SOFTINFOS_SUCCESS = 'GET_SOFTINFOS_SUCCESS';
export const GET_SOFTINFOS_FAILURE = 'GET_SOFTINFOS_FAILURE';

// 6.6 首页改版
export const RECO_TOP_CONTENTS_REQUEST = 'RECO_TOP_CONTENTS_REQUEST';
export const RECO_TOP_CONTENTS_SUCCESS = 'RECO_TOP_CONTENTS_SUCCESS';
export const RECO_TOP_CONTENTS_FAILURE = 'RECO_TOP_CONTENTS_FAILURE';
// 6.6 首页改版
export const RECO_RECOMMEND_CONTENTS_REQUEST = 'RECO_RECOMMEND_CONTENTS_REQUEST';
export const RECO_RECOMMEND_CONTENTS_SUCCESS = 'RECO_RECOMMEND_CONTENTS_SUCCESS';
export const RECO_RECOMMEND_CONTENTS_FAILURE = 'RECO_RECOMMEND_CONTENTS_FAILURE';
// 7.2 其他页面 推荐改版
export const RECOOTHER_TOP_CONTENTS_SUCCESS = 'RECOOTHER_TOP_CONTENTS_SUCCESS';
export const RECOOTHER_TOP_CONTENTS_FAILURE = 'RECOOTHER_TOP_CONTENTS_FAILURE';
// 7.2 其他页面 推荐改版
export const RECOOTHER_RECOMMEND_CONTENTS_SUCCESS = 'RECOOTHER_RECOMMEND_CONTENTS_SUCCESS';
export const RECOOTHER_RECOMMEND_CONTENTS_FAILURE = 'RECOOTHER_RECOMMEND_CONTENTS_FAILURE';
// 7.2 首页改版
export const RECOWORK_TOP_CONTENTS_SUCCESS = 'RECOWORK_TOP_CONTENTS_SUCCESS';
export const RECOWORK_TOP_CONTENTS_FAILURE = 'RECOWORK_TOP_CONTENTS_FAILURE';
// 7.2 首页改版
export const RECOWORK_RECOMMEND_CONTENTS_SUCCESS = 'RECOWORK_RECOMMEND_CONTENTS_SUCCESS';
export const RECOWORK_RECOMMEND_CONTENTS_FAILURE = 'RECOWORK_RECOMMEND_CONTENTS_FAILURE';
